export default {
  back: 'Atrás',
  done: 'Terminado',
};
